/* ============================================================================
   Sixth Man - reveal a product's sizes when a finger drags across it.

   Desktop reveals sizes on hover. This is the touch equivalent, taken
   literally: the size row appears on the tile the finger is over, and ONLY that
   tile. Move to another product and the previous one closes again, exactly as a
   cursor leaving an element would.

   ONE AT A TIME - this is the behaviour Marco asked for after seeing the first
   version, where every tile the finger had ever passed over stayed lit and the
   grid ended up fully open. A hover trail that never clears is not a hover
   trail, it is just a slow reveal-all.

   The last touched tile stays open after the finger lifts rather than snapping
   shut - hover hides on leave, but on touch that would make the sizes
   unreadable: you would have to hold still to read them and they would vanish
   the moment you let go.

   HOW IT WORKS
   On touchmove we ask `elementFromPoint` what is under the finger, walk up to
   the enclosing tile, and move the revealed state there.

   PROGRESSIVE ENHANCEMENT, AND THE DIRECTION MATTERS.
   Rows are visible by default in CSS. This script ADDS the hidden state via
   `sm-reveal-on` on <html>, and only once it is running. No script, a blocked
   script, or a throw = sizes simply always visible.

   That is deliberate: the size row exists because the August ad flight promised
   sizes and the landing page did not confirm them. A reveal that could fail
   CLOSED would rebuild that defect on the device carrying 82% of orders.
   ============================================================================ */
(function () {
  "use strict";

  // Desktop keeps hover - do nothing there.
  if (window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  if (!document.querySelector(".sm-sizes")) return;

  // Arm: only now do the rows start hidden.
  document.documentElement.classList.add("sm-reveal-on");

  var TILE = ".type-product-grid-item, .sitem";
  var active = null;

  function setActive(row) {
    if (row === active) return;
    if (active) active.classList.remove("is-revealed");
    active = row || null;
    if (active) active.classList.add("is-revealed");
  }

  function revealAt(x, y) {
    var el = document.elementFromPoint(x, y);
    if (!el || !el.closest) return;

    var tile = el.closest(TILE);
    if (!tile) return;   // finger is off the grid - leave the current one open

    var row = tile.querySelector(".sm-sizes");
    if (row) setActive(row);
  }

  function onTouch(e) {
    var t = e.touches && e.touches[0];
    if (!t) return;
    revealAt(t.clientX, t.clientY);
  }

  window.addEventListener("touchstart", onTouch, { passive: true, capture: true });
  window.addEventListener("touchmove", onTouch, { passive: true, capture: true });

  window.addEventListener("pointermove", function (e) {
    if (e.pointerType === "mouse") return;
    revealAt(e.clientX, e.clientY);
  }, { passive: true, capture: true });
})();
